import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {TermsAndConditionsActions} from '../store';
import {TermsAndConditionsSelectors} from '../store/selectors';

@Injectable()
export class TermsAndConditionsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadTermsAndConditionsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadTermsAndConditionsDone() {

    return this.store.pipe(
      select(TermsAndConditionsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(TermsAndConditionsActions.ReadTermsAndConditionsEntities());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
